import React from "react";
import "./RewardsTickPageWrapper.scss"
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";

const RewardsTickPageWrapper = ({ children }) => {
    return (
        <div className="RewardsTickPageWrapper">
            <Navbar />
            {children}
            <Footer />
        </div>
    )
}
export default RewardsTickPageWrapper